import React from 'react';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import withAttribute from './withAttribute';
import {
  DATA_ATTR_NODE_TYPE,
  NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_WRAPPER,
} from '@packages/systems/commerce/constants';
import {
  CommerceCheckoutFormConstraint,
  SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
} from '@packages/systems/core/constants/SharedConstraintRules';

import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {Atom} from '@packages/systems/wfdl';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const ShippingAddressWrapper = Atom.createRender(
  ({attributes, classes, data, generateAttributes, renderChild}) => (
    <form {...generateAttributes(attributes, classes)}>
      {getChildren(data).map((child: EvaluatedNodeData) => renderChild(child))}
    </form>
  )
);

const config = createIntegratedAtom({
  displayName: 'Shipping Address',
  showEmpty: true,
  render: withAttribute(
    DATA_ATTR_NODE_TYPE,
    NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_WRAPPER
  )(ShippingAddressWrapper),
  constraints: {
    ancestors: [
      // @ts-expect-error - TS2322 - Type 'RelationshipConstraint | { readonly is: readonly ["CommerceCheckoutFormContainer", "CommercePaypalCheckoutFormContainer"]; readonly name: "Checkout Form"; readonly rule: "ExactlyOne"; }' is not assignable to type 'RelationshipConstraint'.
      ...SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
      // @ts-expect-error - TS2322 - Type '{ readonly is: readonly ["CommerceCheckoutFormContainer", "CommercePaypalCheckoutFormContainer"]; readonly name: "Checkout Form"; readonly rule: "ExactlyOne"; }' is not assignable to type 'RelationshipConstraint'.
      CommerceCheckoutFormConstraint,
    ],
    descendants: [
      ...SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
      {is: 'CommerceCheckoutShippingFullName', rule: 'ExactlyOne'},
      {is: 'CommerceCheckoutShippingCity', rule: 'ExactlyOne'},
      {is: 'CommerceCheckoutShippingStateProvince', rule: 'ExactlyOne'},
      {is: 'CommerceCheckoutShippingStreetAddress', rule: 'ExactlyOne'},
      {is: 'CommerceCheckoutShippingStreetAddressOptional', rule: 'ExactlyOne'},
      {is: 'CommerceCheckoutShippingZipPostalCode', rule: 'ExactlyOne'},
      {is: 'CommerceCheckoutShippingCountrySelector', rule: 'ExactlyOne'},
    ],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginBottom: px(20),
        },
      },
    },
  },
  fields: {children: TListOfElement},
});

export default config;
